module.exports = __webpack_public_path__ + "img/poematio-de-secunda-legione-1768-pagina-de-titlu-big.6effc645.jpg";